import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCertificate,
  faChalkboardUser,
  faArrowUpRightFromSquare,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { certifications, knowledgeSharing } from "../data/portfolioData";

export default function Awards() {
  return (
    <section id="certifications" className="cyber-section">
      <div className="container">
        {/* Section Header */}
        <div className="mb-5">
          <div className="section-label">CREDENTIALS &amp; OUTREACH</div>
          <h2 className="section-title">Certifications &amp; Knowledge Sharing</h2>
          <p className="section-subtitle">
            Industry-recognized foundational certifications alongside technical workshops delivered
            to academic and cybersecurity communities.
          </p>
        </div>

        {/* 1. Verified Certifications */}
        <div className="mb-5">
          <div className="d-flex align-items-center gap-2 mb-4">
            <FontAwesomeIcon icon={faCertificate} style={{ color: "var(--accent)" }} />
            <h3 style={{ fontSize: "1.3rem", fontWeight: 700, margin: 0 }}>
              Verified Certifications
            </h3>
          </div>

          <div className="row g-4">
            {certifications.map((cert, idx) => (
              <div key={idx} className="col-md-6 col-lg-3">
                <div
                  className="cyber-card h-100 d-flex flex-column justify-content-between p-3"
                  style={{
                    background: "var(--bg-surface)",
                    borderColor: "var(--border-subtle)",
                  }}
                >
                  <div>
                    {/* Certificate image preview */}
                    <div
                      className="rounded-2 overflow-hidden mb-3 position-relative"
                      style={{
                        height: "150px",
                        background: "var(--bg-surface-elevated)",
                        border: "1px solid var(--border-subtle)",
                      }}
                    >
                      <img
                        src={cert.image}
                        alt={cert.title}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                      <span
                        className="badge font-mono position-absolute bottom-0 end-0 m-2"
                        style={{
                          background: "rgba(8, 10, 13, 0.85)",
                          border: "1px solid rgba(34, 197, 94, 0.4)",
                          color: "#86efac",
                          fontSize: "0.68rem",
                        }}
                      >
                        <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
                        Verified
                      </span>
                    </div>

                    <div className="font-mono text-muted mb-1" style={{ fontSize: "0.72rem" }}>
                      {cert.issuer}
                    </div>

                    <h4 style={{ fontSize: "0.95rem", fontWeight: 600, color: "var(--text-primary)", marginBottom: "12px", lineHeight: 1.4 }}>
                      {cert.title}
                    </h4>
                  </div>

                  <a
                    href={cert.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-cyber-ghost p-0 mt-2"
                    style={{ fontSize: "0.82rem" }}
                  >
                    Verify Credential <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: "0.75rem" }} />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 2. Knowledge Sharing */}
        <div className="pt-3">
          <div className="d-flex align-items-center gap-2 mb-4">
            <FontAwesomeIcon icon={faChalkboardUser} style={{ color: "#818CF8" }} />
            <h3 style={{ fontSize: "1.3rem", fontWeight: 700, margin: 0 }}>
              Knowledge Sharing &amp; Training
            </h3>
          </div>

          <div className="row g-4">
            {knowledgeSharing.map((item, idx) => (
              <div key={idx} className="col-lg-4 col-md-6">
                <div
                  className="cyber-card h-100 d-flex flex-column justify-content-between p-4"
                  style={{
                    background: "var(--bg-surface)",
                    borderColor: "var(--border-subtle)",
                  }}
                >
                  <div>
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span
                        className="badge font-mono"
                        style={{
                          background: "rgba(129, 140, 248, 0.1)",
                          color: "#818CF8",
                          border: "1px solid rgba(129, 140, 248, 0.3)",
                          fontSize: "0.7rem",
                        }}
                      >
                        {item.type}
                      </span>
                      <span className="font-mono text-muted" style={{ fontSize: "0.72rem" }}>
                        {item.audience}
                      </span>
                    </div>

                    <h4 style={{ fontSize: "1.1rem", fontWeight: 700, color: "var(--text-primary)", marginBottom: "12px" }}>
                      {item.topic}
                    </h4>

                    <p style={{ fontSize: "0.88rem", color: "var(--text-secondary)", lineHeight: 1.6, marginBottom: "0" }}>
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
